import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconTaskJoin = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="102"
      height="48"
      viewBox="0 0 102 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...omit(props, ["className"])}
      ref={ref}
      className="yfm-icon yfm-icon-task-join"
    >
      <path
        d="M26.96 0H77.96C91.2148 0 101.96 10.7452 101.96 24C101.96 37.2548 91.2148 48 77.96 48H3.45996L26.96 0Z"
        fill="url(#paint0_linear_2073_502)"
      />
      <path
        d="M12.5854 0.5H31.4272L22.562 15.9893L22.561 15.9912C22.236 16.5648 22.641 17.2998 23.3198 17.2998H25.4233C27.5415 17.2998 28.674 19.7359 27.3989 21.3428L27.2681 21.4951L4.64795 45.9531L10.9604 27.0508L10.9614 27.0479C11.1467 26.4822 10.7293 25.9004 10.1294 25.9004H3.29736C1.47685 25.9003 0.264797 24.0207 1.01514 22.3652L10.3032 1.96484L10.3022 1.96387C10.7095 1.07386 11.6031 0.500027 12.5854 0.5Z"
        fill="url(#paint1_linear_2073_502)"
        stroke="url(#paint2_linear_2073_502)"
      />
      <path
        d="M69.48 26.312C69.48 28.076 68.4 29.084 66.66 29.084C65.532 29.084 64.62 28.604 63.912 27.776L64.788 26.432C65.376 27.056 66.048 27.368 66.564 27.368C67.188 27.368 67.572 26.984 67.572 26.264V22.208H64.68V20.6H69.48V26.312ZM74.0569 22.484C76.1209 22.484 77.5129 23.792 77.5129 25.772C77.5129 27.74 76.1209 29.072 74.0569 29.072C71.9809 29.072 70.5889 27.74 70.5889 25.772C70.5889 23.792 71.9809 22.484 74.0569 22.484ZM74.0569 24.02C73.0969 24.02 72.4369 24.74 72.4369 25.796C72.4369 26.852 73.0969 27.572 74.0569 27.572C75.0049 27.572 75.6649 26.852 75.6649 25.796C75.6649 24.74 75.0049 24.02 74.0569 24.02ZM79.6587 19.784C80.1867 19.784 80.5587 20.168 80.5587 20.708C80.5587 21.236 80.1867 21.632 79.6587 21.632C79.1307 21.632 78.7587 21.236 78.7587 20.708C78.7587 20.168 79.1307 19.784 79.6587 19.784ZM78.7347 22.544H80.5827V29H78.7347V22.544ZM86.4358 22.472C87.8758 22.472 88.7998 23.432 88.7998 24.944V29H86.9518V25.484C86.9518 24.668 86.4718 24.164 85.6798 24.164C84.7558 24.176 84.2038 24.872 84.2038 25.82V29H82.3558V22.544H84.2038V23.672C84.6598 22.868 85.4278 22.484 86.4358 22.472Z"
        fill="white"
      />
      <path
        d="M34.9219 23.6072C34.871 23.6072 34.8591 23.5823 34.884 23.5433L35.1505 23.202C35.1754 23.1641 35.2383 23.1392 35.2892 23.1392H39.8088C39.8587 23.1392 39.8717 23.1771 39.8468 23.215L39.6312 23.5433C39.6063 23.5823 39.5423 23.6191 39.5044 23.6191L34.9219 23.6072ZM33.0109 24.7718C32.96 24.7718 32.947 24.7469 32.973 24.709L33.2384 24.3666C33.2633 24.3287 33.3273 24.3038 33.3782 24.3038H39.1502C39.2011 24.3038 39.226 24.3417 39.213 24.3796L39.1123 24.683C39.0993 24.7339 39.0494 24.7588 38.9985 24.7588L33.0109 24.7718ZM36.0746 25.9364C36.0237 25.9364 36.0107 25.8985 36.0367 25.8605L36.2133 25.5442C36.2382 25.5063 36.2891 25.4684 36.34 25.4684H38.8718C38.9227 25.4684 38.9476 25.5063 38.9476 25.5572L38.9227 25.8605C38.9227 25.9115 38.8718 25.9494 38.8338 25.9494L36.0746 25.9364ZM49.2143 23.3797C48.417 23.5823 47.8721 23.734 47.0878 23.9365C46.8971 23.9864 46.8852 23.9994 46.7194 23.8098C46.5309 23.5942 46.3912 23.4555 46.1258 23.3288C45.3273 22.9366 44.5549 23.0504 43.8345 23.5184C42.9733 24.0752 42.5302 24.8985 42.5432 25.9234C42.5551 26.9363 43.2517 27.7715 44.2516 27.9113C45.1128 28.025 45.8333 27.7217 46.4042 27.076C46.5179 26.9363 46.6187 26.7846 46.7454 26.607H44.3025C44.0371 26.607 43.9732 26.4423 44.062 26.2278C44.2267 25.8356 44.53 25.177 44.7077 24.8476C44.7348 24.7866 44.7792 24.7349 44.8355 24.6989C44.8917 24.6629 44.9572 24.6442 45.024 24.645H49.6314C49.6065 24.9874 49.6065 25.3286 49.5556 25.671C49.4244 26.5722 49.0674 27.4256 48.5178 28.1518C47.6067 29.3543 46.4161 30.1018 44.9103 30.3033C43.6698 30.468 42.5172 30.2275 41.5053 29.4691C40.5683 28.7595 40.0363 27.8225 39.8977 26.6579C39.733 25.2777 40.1382 24.0373 40.9734 22.9485C41.8726 21.772 43.0621 21.0245 44.5181 20.7591C45.7076 20.5435 46.8473 20.6833 47.8721 21.3788C48.5438 21.823 49.0237 22.4296 49.3411 23.1641C49.4169 23.2779 49.366 23.3418 49.2143 23.3797ZM53.4047 30.3802C52.252 30.3542 51.2012 30.0249 50.315 29.2655C49.5778 28.6442 49.0918 27.7758 48.9478 26.8225C48.7203 25.3925 49.1125 24.1261 49.9738 22.9995C50.8978 21.784 52.0115 21.1513 53.5184 20.8859C54.8097 20.6584 56.0253 20.7841 57.1259 21.5316C58.1258 22.2141 58.7466 23.1392 58.9113 24.3536C59.1258 26.0631 58.6328 27.4552 57.4553 28.6458C56.62 29.4941 55.5941 30.0249 54.4165 30.2654C54.0753 30.3293 53.734 30.3412 53.4047 30.3802ZM56.4163 25.2658C56.4044 25.1011 56.4044 24.9744 56.3795 24.8476C56.152 23.5942 54.9993 22.8857 53.7968 23.1641C52.6193 23.4295 51.8598 24.177 51.5814 25.3665C51.3539 26.3545 51.8349 27.3545 52.746 27.7596C53.4426 28.063 54.1381 28.0251 54.8098 27.6838C55.8097 27.1638 56.3535 26.3545 56.4174 25.2658H56.4163Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2073_502"
          x1="53.96"
          y1="0"
          x2="53.96"
          y2="48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF755A" />
          <stop offset="1" stopColor="#FF3A0D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2073_502"
          x1="16.2886"
          y1="0"
          x2="41.4576"
          y2="6.9914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF502D" />
          <stop offset="1" stopColor="#FFBF00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2073_502"
          x1="15.95"
          y1="23.0204"
          x2="26.7356"
          y2="28.9138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stop-opacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  )
);

IconTaskJoin.displayName = "IconTaskJoin";

export default IconTaskJoin;
